/**
 * LP Section Configs — defines sections, icons, and defaults for each Landing Page.
 * Used by both LPLayoutManager (admin) and the LP pages themselves (frontend rendering).
 */
import {
  Layout, Users, Star, Heart, Shield, Brain, Target, Activity,
  Quote, Calendar, Zap, MessageSquare, Phone, DollarSign, AlertTriangle,
  Play, BookOpen, MapPin, Award, TrendingUp, Briefcase, Building,
  Eye, Lightbulb, Rocket, BarChart, HandHeart, Clock, HelpCircle,
  Mail, FileText, CheckCircle, Sparkles, Dumbbell, Leaf
} from 'lucide-react';

// ===== BookFirstClass =====
export const BOOK_FIRST_CLASS_SECTIONS = [
  { id: 'hero', name: 'Hero Section', icon: Layout, visible: true, locked: true },
  { id: 'slots', name: 'Slots / Schedule', icon: Calendar, visible: true },
  { id: 'problem', name: 'Problem Section', icon: AlertTriangle, visible: true },
  { id: 'solution', name: 'Solution Section', icon: Lightbulb, visible: true },
  { id: 'beginner', name: 'Beginner Section', icon: Heart, visible: true },
  { id: 'method', name: 'Method Section', icon: Brain, visible: true },
  { id: 'testimonials', name: 'Testimonials', icon: Quote, visible: true },
  { id: 'video', name: 'Video Section', icon: Play, visible: true },
  { id: 'instructor', name: 'Instructor Section', icon: Users, visible: true },
  { id: 'research', name: 'Research Section', icon: BookOpen, visible: true },
  { id: 'value', name: 'Value Proposition', icon: Award, visible: true },
  { id: 'experience_pass', name: 'Experience Pass', icon: Sparkles, visible: true },
  { id: 'post_pass_benefits', name: 'Post-Pass Benefits', icon: Heart, visible: true },
  { id: 'urgency_slots', name: 'Urgency Countdown', icon: Clock, visible: true },
  { id: 'location', name: 'Location / Map', icon: MapPin, visible: true },
  { id: 'final_cta', name: 'Final CTA', icon: Zap, visible: true },
  { id: 'faq', name: 'FAQ Section', icon: HelpCircle, visible: true },
  { id: 'address', name: 'Address & Directions', icon: MapPin, visible: true },
  { id: 'contact', name: 'Contact Info', icon: Phone, visible: true },
  { id: 'gstin', name: 'GSTIN / Business Info', icon: FileText, visible: true },
];

// ===== Corporate =====
export const CORPORATE_SECTIONS = [
  { id: 'hero', name: 'Hero Section', icon: Layout, visible: true, locked: true },
  { id: 'problem', name: 'The Problem', icon: AlertTriangle, visible: true },
  { id: 'shift', name: 'The Shift', icon: TrendingUp, visible: true },
  { id: 'solution', name: 'The Solution', icon: Lightbulb, visible: true },
  { id: 'deploy', name: 'How to Deploy', icon: Rocket, visible: true },
  { id: 'workplace', name: 'Workplace Impact', icon: Building, visible: true },
  { id: 'howitworks', name: 'How It Works', icon: Target, visible: true },
  { id: 'whysama', name: 'Why SAMA', icon: Star, visible: true },
  { id: 'team', name: 'Team Section', icon: Users, visible: true },
  { id: 'proof', name: 'Social Proof', icon: Award, visible: true },
  { id: 'outcomes', name: 'Outcomes', icon: BarChart, visible: true },
  { id: 'engagement', name: 'Engagement Models', icon: Briefcase, visible: true },
  { id: 'final_cta', name: 'Final CTA', icon: Zap, visible: true },
];

// ===== Franchise =====
export const FRANCHISE_SECTIONS = [
  { id: 'hero', name: 'Hero Section', icon: Layout, visible: true, locked: true },
  { id: 'market', name: 'Market Opportunity', icon: TrendingUp, visible: true },
  { id: 'whysama', name: 'Why SAMA', icon: Star, visible: true },
  { id: 'opportunity', name: 'The Opportunity', icon: Lightbulb, visible: true },
  { id: 'formats', name: 'Studio Formats', icon: Building, visible: true },
  { id: 'economics', name: 'Unit Economics', icon: DollarSign, visible: true },
  { id: 'support', name: 'Support & Training', icon: HandHeart, visible: true },
  { id: 'system', name: 'Tech & Systems', icon: Activity, visible: true },
  { id: 'partners', name: 'Partners & Investors', icon: Briefcase, visible: true },
  { id: 'vision', name: 'Vision & Roadmap', icon: Eye, visible: true },
  { id: 'team', name: 'Team Section', icon: Users, visible: true },
  { id: 'faq', name: 'FAQ Section', icon: HelpCircle, visible: true },
  { id: 'leadform', name: 'Lead Capture Form', icon: MessageSquare, visible: true },
];

// ===== MindfulStrength =====
export const MINDFUL_STRENGTH_SECTIONS = [
  { id: 'hero', name: 'Hero Section', icon: Layout, visible: true, locked: true },
  { id: 'whystrength', name: 'Why Strength Training', icon: Dumbbell, visible: true },
  { id: 'who', name: 'Who This Is For', icon: Users, visible: true },
  { id: 'pillars', name: 'Key Pillars', icon: Star, visible: true },
  { id: 'sessionflow', name: 'Session Flow', icon: Activity, visible: true },
  { id: 'outcomes', name: 'Outcomes', icon: CheckCircle, visible: true },
  { id: 'mindful', name: 'Mindful Approach', icon: Leaf, visible: true },
  { id: 'flexibility', name: 'Flexibility & Packages', icon: Heart, visible: true },
  { id: 'testimonials', name: 'Testimonials', icon: Quote, visible: true },
  { id: 'urgency', name: 'Urgency Callout', icon: AlertTriangle, visible: true },
  { id: 'staticschedule', name: 'Static Schedule', icon: Calendar, visible: true },
  { id: 'leadform', name: 'Lead Capture Form', icon: MessageSquare, visible: true },
  { id: 'finalcta', name: 'Final CTA', icon: Zap, visible: true },
];

// ===== PrivateClasses =====
export const PRIVATE_CLASSES_SECTIONS = [
  { id: 'hero', name: 'Hero Section', icon: Layout, visible: true, locked: true },
  { id: 'who', name: 'Who This Is For', icon: Users, visible: true },
  { id: 'pillars', name: '4 Pillars', icon: Star, visible: true },
  { id: 'whatyouget', name: 'What You Get', icon: Activity, visible: true },
  { id: 'programs', name: 'Program Options', icon: Target, visible: true },
  { id: 'outcomes', name: 'Outcomes', icon: Heart, visible: true },
  { id: 'testimonials', name: 'Testimonials', icon: Quote, visible: true },
  { id: 'urgency', name: 'Urgency Callout', icon: AlertTriangle, visible: true },
  { id: 'pricing', name: 'Pricing Callout', icon: DollarSign, visible: true },
  { id: 'leadform', name: 'Lead Capture Form', icon: MessageSquare, visible: true },
  { id: 'finalcta', name: 'Final CTA', icon: Phone, visible: true },
];

// ===== BookingConfirmed =====
export const BOOKING_CONFIRMED_SECTIONS = [
  { id: 'header', name: 'Success Header', icon: CheckCircle, visible: true, locked: true },
  { id: 'what_to_expect', name: 'What to Expect', icon: Sparkles, visible: true },
  { id: 'whatsapp_nudge', name: 'WhatsApp / Get Directions', icon: MessageSquare, visible: true },
  { id: 'booking_details', name: 'Booking Details Card', icon: FileText, visible: true },
  { id: 'whatsapp_notice', name: 'WhatsApp Notice', icon: Phone, visible: true },
  { id: 'calendar', name: 'Add to Calendar', icon: Calendar, visible: true },
  { id: 'invite_friend', name: 'Invite a Friend', icon: Heart, visible: true },
  { id: 'need_help', name: 'Need Help', icon: HelpCircle, visible: true },
  { id: 'back_home', name: 'Back to Home', icon: Layout, visible: true },
];

// Layout section keys used for CMS storage
export const LP_LAYOUT_KEYS = {
  book_first_class: 'book_first_class_layout',
  corporate: 'corporate_layout',
  franchise: 'franchise_layout',
  mindful_strength: 'mindful_strength_layout',
  private_classes: 'private_classes_layout',
  booking_confirmed: 'booking_confirmed_layout',
};
